import { app } from '../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
	$stateProvider.states = (statesArr, obj) => {
		
		for (var i in statesArr) {
			var state = statesArr[i];
			$stateProvider.state(state, angular.copy(obj));
		}

		return $stateProvider;
	}
}


// WEBPACK FOOTER //
// ./src/portal/config/states-provider.config.js